// PDF reservation ticket. Drawn on a canvas with the site's web fonts (so
// Turkish letters and DM Serif render correctly), then wrapped into a PDF.
// jsPDF is loaded only when the guest asks for the ticket.

// Dark burgundy, matching the emails.
const C = {
  bone: '#f3eadf', paper: '#2a2023', ink: '#f3eadf', body: '#d9cbbd', muted: '#a99886',
  cobalt: '#1f3a6b', oxblood: '#6e1a1f', terracotta: '#e7b9bd', saffron: '#d4a24c',
  stub: '#4a1620', rose: '#e7b9bd', notch: '#ffffff', rule: 'rgba(243,234,223,.2)',
};
const L = {
  tr: { kicker: 'Rezervasyon talebi', name: 'Misafir', date: 'Tarih', time: 'Saat', guests: 'Kişi', sitting: 'Oturum', note: 'Not', code: 'Kod', foot: 'Teyit için seni arayacağız', person: 'kişi' },
  en: { kicker: 'Reservation request', name: 'Guest', date: 'Date', time: 'Time', guests: 'Guests', sitting: 'Sitting', note: 'Note', code: 'Code', foot: 'We will call you to confirm', person: 'guests' },
  fr: { kicker: 'Demande de réservation', name: 'Invité', date: 'Date', time: 'Heure', guests: 'Couverts', sitting: 'Service', note: 'Note', code: 'Code', foot: 'Nous vous rappelons pour confirmer', person: 'pers.' },
  es: { kicker: 'Solicitud de reserva', name: 'Invitado', date: 'Fecha', time: 'Hora', guests: 'Personas', sitting: 'Turno', note: 'Nota', code: 'Código', foot: 'Te llamamos para confirmar', person: 'pers.' },
};
const SITTING = { tr: { brunch: 'Brunch', dinner: 'Akşam yemeği' }, en: { brunch: 'Brunch', dinner: 'Dinner' }, fr: { brunch: 'Brunch', dinner: 'Dîner' }, es: { brunch: 'Brunch', dinner: 'Cena' } };
const LOCALE = { tr: 'tr-TR', en: 'en-GB', fr: 'fr-FR', es: 'es-ES' };

const star = (ctx, cx, cy, r) => {
  ctx.beginPath();
  for (let i = 0; i < 16; i += 1) {
    const a = (Math.PI / 8) * i - Math.PI / 2;
    const rr = i % 2 === 0 ? r : r * 0.72;
    ctx[i ? 'lineTo' : 'moveTo'](cx + rr * Math.cos(a), cy + rr * Math.sin(a));
  }
  ctx.closePath();
};
const tile = (ctx, x, y, s, [bg, fg, ac]) => {
  ctx.fillStyle = bg; ctx.fillRect(x, y, s, s);
  ctx.fillStyle = fg; star(ctx, x + s / 2, y + s / 2, s * 0.38); ctx.fill();
  ctx.fillStyle = bg; star(ctx, x + s / 2, y + s / 2, s * 0.22); ctx.fill();
  ctx.fillStyle = ac; ctx.beginPath(); ctx.arc(x + s / 2, y + s / 2, s * 0.08, 0, Math.PI * 2); ctx.fill();
};
const THEMES = [[C.cobalt, C.bone, C.terracotta], [C.oxblood, C.bone, C.saffron], [C.saffron, '#13244a', C.oxblood]];
const label = (ctx, text, x, y, color = C.muted) => {
  ctx.font = '600 15px "Instrument Sans", Arial, sans-serif';
  ctx.fillStyle = color;
  ctx.fillText(text.toLocaleUpperCase(), x, y);
};
const fit = (ctx, text, maxW) => {
  let t = text;
  while (ctx.measureText(t).width > maxW && t.length > 3) t = `${t.slice(0, -2)}…`;
  return t;
};

const drawTicket = (r) => {
  const t = L[r.lang] || L.tr;
  const W = 1600; const H = 760; const STUB = 430; const MAIN = W - STUB;
  const cv = document.createElement('canvas');
  cv.width = W; cv.height = H;
  const ctx = cv.getContext('2d');
  ctx.letterSpacing = '0px';

  // paper and stub
  ctx.fillStyle = C.paper; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = C.stub; ctx.fillRect(MAIN, 0, STUB, H);

  // tile band along the top of the main part
  const s = 64;
  for (let i = 0; i * s < MAIN; i += 1) tile(ctx, i * s, 0, s, THEMES[i % 6 === 2 ? 1 : i % 5 === 0 ? 2 : 0]);
  ctx.fillStyle = C.saffron; ctx.fillRect(0, s, MAIN, 4);

  // perforation with notches
  ctx.fillStyle = C.notch;
  ctx.beginPath(); ctx.arc(MAIN, 0, 26, 0, Math.PI); ctx.fill();
  ctx.beginPath(); ctx.arc(MAIN, H, 26, Math.PI, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = 'rgba(244,239,230,.55)'; ctx.lineWidth = 3; ctx.setLineDash([10, 10]);
  ctx.beginPath(); ctx.moveTo(MAIN, 40); ctx.lineTo(MAIN, H - 40); ctx.stroke(); ctx.setLineDash([]);

  // brand
  const x0 = 70;
  label(ctx, t.kicker, x0, 130, C.terracotta);
  ctx.fillStyle = C.ink; ctx.font = '76px "DM Serif Display", Georgia, serif';
  ctx.fillText('Lucien', x0, 215);
  const lw = ctx.measureText('Lucien').width;
  ctx.fillStyle = C.rose; ctx.fillText('14', x0 + lw + 4, 215);

  // date and time
  const [y, m, d] = r.date.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  const weekday = dt.toLocaleDateString(LOCALE[r.lang] || 'tr-TR', { weekday: 'long' });
  label(ctx, t.date, x0, 300);
  ctx.fillStyle = C.ink; ctx.font = '64px "DM Serif Display", Georgia, serif';
  ctx.fillText(`${String(d).padStart(2, '0')}.${String(m).padStart(2, '0')}.${y}`, x0, 370);
  ctx.fillStyle = C.body; ctx.font = 'italic 30px "Libre Caslon Text", Georgia, serif';
  ctx.fillText(weekday, x0, 412);

  label(ctx, t.time, 560, 300);
  ctx.fillStyle = C.terracotta; ctx.font = '96px "DM Serif Display", Georgia, serif';
  ctx.fillText(r.time, 556, 384);

  // guest details
  ctx.strokeStyle = C.rule; ctx.lineWidth = 2;
  ctx.beginPath(); ctx.moveTo(x0, 460); ctx.lineTo(MAIN - 70, 460); ctx.stroke();
  const col = (lbl, val, x, w) => {
    label(ctx, lbl, x, 505);
    ctx.fillStyle = C.ink; ctx.font = '34px "DM Serif Display", Georgia, serif';
    ctx.fillText(fit(ctx, val, w), x, 552);
  };
  col(t.name, r.name, x0, 440);
  col(t.sitting, SITTING[r.lang]?.[r.type] || r.type, 540, 260);
  col(t.guests, `${r.guests} ${t.person}`, 830, 260);
  if (r.note) {
    label(ctx, t.note, x0, 612);
    ctx.fillStyle = C.body; ctx.font = '26px "Libre Caslon Text", Georgia, serif';
    ctx.fillText(fit(ctx, r.note, MAIN - 2 * x0), x0, 652);
  }
  ctx.fillStyle = C.muted; ctx.font = 'italic 22px "Libre Caslon Text", Georgia, serif';
  ctx.fillText(`${t.foot} · lucien14.com`, x0, H - 40);

  // stub: big time, guests and code
  const sx = MAIN + STUB / 2;
  ctx.textAlign = 'center';
  tile(ctx, sx - 34, 70, 68, THEMES[1]);
  label(ctx, SITTING[r.lang]?.[r.type] || r.type, sx, 200, C.saffron);
  ctx.fillStyle = C.bone; ctx.font = '88px "DM Serif Display", Georgia, serif';
  ctx.fillText(r.time, sx, 300);
  ctx.font = '34px "DM Serif Display", Georgia, serif';
  ctx.fillText(`${String(d).padStart(2, '0')}.${String(m).padStart(2, '0')}`, sx, 352);
  ctx.fillText(`${r.guests} ${t.person}`, sx, 400);
  label(ctx, t.code, sx, 560, 'rgba(244,239,230,.65)');
  ctx.fillStyle = C.saffron; ctx.font = '600 34px "Instrument Sans", Arial, sans-serif';
  ctx.fillText((r.code || '').slice(0, 8).toUpperCase(), sx, 606);
  ctx.textAlign = 'start';
  return cv;
};

const makePdf = async (r, quality) => {
  if (document.fonts?.ready) await document.fonts.ready;
  const cv = drawTicket(r);
  const { jsPDF } = await import('jspdf');
  const pdf = new jsPDF({ orientation: 'landscape', unit: 'px', format: [cv.width, cv.height], hotfixes: ['px_scaling'] });
  pdf.addImage(cv.toDataURL('image/jpeg', quality), 'JPEG', 0, 0, cv.width, cv.height);
  return pdf;
};
const fileName = (r) => `Lucien14-${r.date}-${r.time.replace(':', '')}.pdf`;

export const downloadTicket = async (r) => {
  (await makePdf(r, 0.92)).save(fileName(r));
};

// The same ticket as base64, attached to the guest's email by the Apps Script.
export const ticketAttachment = async (r) => {
  const uri = (await makePdf(r, 0.85)).output('datauristring');
  return { name: fileName(r), data: uri.slice(uri.indexOf(',') + 1) };
};


